<style>
</style>
<template>
  <div class="msgRecord-box">
    <p class="title">短信管理&nbsp;&nbsp;<strong>[ 短信发送记录 ]</strong></p>
    <el-table :data="mdgRecordData" border>
      <!-- <el-table-column label="用户ID"  prop="userId"></el-table-column> -->
      <el-table-column label="发送人" prop="userName"></el-table-column>
      <el-table-column label="接收人" prop="mobilePhone"></el-table-column>
      <el-table-column label="短信内容" prop="smsContent" width="380px"></el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.smsStatus == 0">成功</el-tag>
          <el-tag type="info" v-else-if ="scope.row.smsStatus == -1">发送中</el-tag>
          <el-tag type="warning" v-else>失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="扣费次数 (条) "  prop="smsBillingNumber"></el-table-column>
      <el-table-column label="发送时间" prop="smsSendTimeStr"></el-table-column>
    </el-table>
    <div class="block mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "msgRecord",
  data(){
    return{
      pageSize: 10,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      mdgRecordData: [],
    };
  },
  created(){
    this.getMsgRecord()
  },
  methods: {
    getMsgRecord(){//获取列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        // "startTime":
        // "endTime":
        // "userName":
        // "smsStatus":
        // "userPhone":
      }
      api.getRecordList({data:data}).then(res => {
        if(res.status == 'success'){
          this.mdgRecordData = res.data.resultList;
          this.total = res.data.count;
        }
      })
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getMsgRecord();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getMsgRecord();
    },
  },
  components: {
    
  }
}
</script> 
  




// WEBPACK FOOTER //
// src/view/autograph/msgRecord.vue